<section>
  <app-form-header [menuDefinition]="menuDefinition" (onSave)="onSubmit()" (onCancel)="cancel()"></app-form-header>

  @if (form) {
    <form class="astral-content-width astral-content-width--with-list-surface astral-stack-l" [formGroup]="form" (ngSubmit)="onSubmit()">
      <section class="astral-section-surface astral-form-stack">
        <astral-layout-group [columns]="3" [tabletColumns]="2" [mobileColumns]="1">
          <astral-select [control]="form.controls['company']" [itemsSource]="companies"></astral-select>
          <astral-input [control]="form.controls['propertyNumber']"></astral-input>
          <astral-input [control]="form.controls['propertyName']" [helpText]="'PROPERTY.HELP_TEXT.PROPERTYNAME'"></astral-input>
          <astral-input [control]="form.controls['municipality']"></astral-input>
          <astral-input [control]="form.controls['costPlace']"></astral-input>
          <astral-input [control]="form.controls['costBearer']"></astral-input>
          @if (isHomeQUsed) {
            <astral-input
              label="PROPERTY.HOMEQ_OFFICE"
              [value]="homeQOfficeName === '' ? ('CONST.NONE' | translate) : homeQOfficeName"
              [helpText]="'PROPERTY.HELP_TEXT.HOMEQ_OFFICE'"
              [readonly]="true"
            ></astral-input>
          }
        </astral-layout-group>

        <app-negotiation [form]="form" [dataContext]="dataContext"></app-negotiation>

        @if (customProperties.length) {
          <astral-layout-group [columns]="4" [tabletColumns]="2" [mobileColumns]="1">
            @for (property of customProperties; track property) {
              @if (property.showNumeric || property.showInt) {
                <astral-input type="number" [control]="property.form.controls['numericValue']"></astral-input>
              }
              @if (property.showText) {
                <astral-input [control]="property.form.controls['textValue']"></astral-input>
              }
              @if (property.showBoolean) {
                <astral-checkbox [control]="property.form.controls['boolValue']"></astral-checkbox>
              }
              @if (property.showSelection) {
                <astral-select [control]="property.form.controls['textValue']" [itemsSource]="property.selection"></astral-select>
              }
              @if (property.showDate) {
                <astral-date-picker [control]="property.form.controls['dateValue']"></astral-date-picker>
              }
            }
          </astral-layout-group>
        }

        <astral-textarea [control]="form.controls['note']" [rows]="4"></astral-textarea>
      </section>

      <section class="astral-section-surface astral-stack-l">
        <h4>{{ 'AREA.AREA' | translate }}</h4>

        @for (group of $any(areas.controls); track group; let i = $index) {
          <section class="astral-section-surface astral-section-surface--compact astral-stack-m">
            <astral-layout-group [columns]="5" [tabletColumns]="2" [mobileColumns]="1">
              <astral-select [control]="group.controls['type']" [itemsSource]="areaTypes"></astral-select>
              <astral-input type="number" [control]="group.controls['value']"></astral-input>
              <astral-date-picker [control]="group.controls['measuredDate']"></astral-date-picker>
              <astral-input [control]="group.controls['measuredBy']"></astral-input>
              <div class="astral-form-adjacent-action">
                <astral-button variant="secondary" size="small" type="button" icon="trash" labelKey="DELETE_BTN" (click)="removeArea(i)"></astral-button>
              </div>
            </astral-layout-group>
          </section>
        }

        <astral-button variant="primary" size="small" type="button" icon="plus" labelKey="AREA.ADD_AREA" (click)="addArea()"></astral-button>
      </section>

      @if (dataContext.hasBuildings) {
        <section class="astral-section-surface astral-section-surface--list-width astral-stack-l">
          <h4>{{ 'BUILDING_LIST.HEADER' | translate }}</h4>
          <app-list-view
            [columnDefinition]="buildingColumnDefinition"
            [itemsSource]="dataContext.buildings"
            [preferencesKey]="'rent.property.buildings'"
            (rowClick)="onBuildingRowClicked($event)"
          ></app-list-view>
        </section>
      }

      <div class="astral-accordion-stack">
        <astral-accordion [header]="'PROPERTY.RESPONSIBILITIES'" [helpText]="'PROPERTY.HELP_TEXT.RESPONSIBILITIES'">
          <div class="astral-stack-l">
            <section class="astral-accordion-section">
              <h3 class="astral-section-heading astral-accordion-section__heading">{{ 'PROPERTY.FAULTNOTIFICATION_RECIPIENT' | translate }}</h3>
              <astral-layout-group [columns]="3" [tabletColumns]="2" [mobileColumns]="1">
                <app-autocomplete
                  [control]="form.controls['faultNotificationRecipient']"
                  [itemsSource]="executorWebUsers"
                  [helpText]="'PROPERTY.HELP_TEXT.FAULTNOTIFICATION_RECIPIENT'"
                ></app-autocomplete>
                <app-autocomplete
                  [control]="form.controls['faultNotificationExecutorGroup']"
                  [itemsSource]="executorGroups"
                  [helpText]="'PROPERTY.HELP_TEXT.FAULT_NOTIFICATION_EXECUTOR_GROUP'"
                ></app-autocomplete>
                <app-autocomplete
                  [control]="form.controls['faultNotificationExecutorWebUser']"
                  [itemsSource]="faultNotificationExecutorWebUsers"
                  [helpText]="'PROPERTY.HELP_TEXT.FAULT_NOTIFICATION_EXECUTOR_WEB_USER'"
                ></app-autocomplete>
              </astral-layout-group>
            </section>

            <section class="astral-accordion-section">
              <h3 class="astral-section-heading astral-accordion-section__heading">{{ 'PROPERTY.DWELLING_INSPECTION_RECIPIENT' | translate }}</h3>
              <astral-layout-group [columns]="3" [tabletColumns]="2" [mobileColumns]="1">
                <app-autocomplete
                  [control]="form.controls['dwellingInspectionExecutorWebUser']"
                  [itemsSource]="inspectorWebUsers"
                  [helpText]="'PROPERTY.HELP_TEXT.DWELLING_INSPECTION_EXECUTOR_WEB_USER'"
                ></app-autocomplete>
              </astral-layout-group>
            </section>

            @if (allowErrandSubCategoryResponsibilities && !dataContext.isNew) {
              <app-property-errand-subcategory-responsibility [propertyId]="dataContext.id"></app-property-errand-subcategory-responsibility>
            }
          </div>
        </astral-accordion>

        <app-property-tax-form
          [propertyId]="dataContext.id"
          [propertyName]="dataContext.propertyName"
          [buildings]="$safeNavigationMigration(dataContext?.buildings)"
          (propertyTaxesChange)="onPropertyTaxesChange($event)"
          [propertyTaxValues]="$safeNavigationMigration(dataContext?.propertyTaxValuesByYear)"
          [propertyTaxes]="$safeNavigationMigration(dataContext?.propertyTaxes)"
        ></app-property-tax-form>

        @if (!dataContext.isNew) {
          <astral-accordion [header]="'LEASE_AGREEMENT.INVOICING_HEADER'">
            <astral-layout-group [columns]="2" [tabletColumns]="2" [mobileColumns]="1">
              <astral-select
                [control]="form.controls['companyBankAccountId']"
                [itemsSource]="companyBankAccountSelection"
                [helpText]="'PROPERTY.HELP_TEXT.DEFAULT_INVOICE_ACCOUNT'"
              ></astral-select>
              <astral-input [control]="form.controls['paymentReceiver']" [helpText]="'PROPERTY.HELP_TEXT.PAYMENTRECEIVER'"></astral-input>
            </astral-layout-group>
          </astral-accordion>
        }

        <astral-accordion [header]="'COMPANY.TEMPLATE_VALUES_NEW_LEASEAGREEMENT'" [helpText]="'COMPANY.HELP_TEXT.TEMPLATE_VALUES_NEW_LEASEAGREEMENT'">
          <div class="astral-stack-l">
            <div class="astral-form-stack">
              <astral-textarea [control]="form.controls['generalTermsDwelling']" [helpText]="'COMPANY.HELP_TEXT.GENERAL_TERMS_DWELLING'" [rows]="4"></astral-textarea>
              <astral-textarea [control]="form.controls['generalTermsParking']" [helpText]="'COMPANY.HELP_TEXT.GENERAL_TERMS_PARKING'" [rows]="4"></astral-textarea>
              <astral-textarea [control]="form.controls['specialTermsDwelling']" [helpText]="'COMPANY.HELP_TEXT.SPECIAL_TERMS_DWELLING'" [rows]="4"></astral-textarea>
              <astral-textarea [control]="form.controls['specialTermsParking']" [helpText]="'COMPANY.HELP_TEXT.SPECIAL_TERMS_PARKING'" [rows]="4"></astral-textarea>
              <astral-textarea [control]="form.controls['rentPaymentTermsDwelling']" [helpText]="'COMPANY.HELP_TEXT.RENT_PAYMENT_TERMS'" [rows]="4"></astral-textarea>
              <astral-textarea [control]="form.controls['rentPaymentTermsParking']" [helpText]="'COMPANY.HELP_TEXT.RENT_PAYMENT_TERMS'" [rows]="4"></astral-textarea>
            </div>

            <app-information-block [text]="'APPENDIX.HELP_TEXT.APPENDIX_PROPERTY_DWELLING' | translate"></app-information-block>

            @for (group of $any(appendices.controls); track group; let i = $index) {
              <section class="astral-section-surface astral-section-surface--compact astral-stack-m">
                <astral-layout-group [columns]="3" [tabletColumns]="2" [mobileColumns]="1">
                  <astral-select [control]="group.controls['appendix']" [itemsSource]="appendixTitles"></astral-select>
                  <astral-select [control]="group.controls['sortOrder']" [itemsSource]="orderSelection"></astral-select>
                  <div class="astral-form-adjacent-action">
                    <astral-button variant="secondary" size="small" type="button" icon="trash" labelKey="DELETE_BTN" (click)="removeAppendix(i)"></astral-button>
                  </div>
                </astral-layout-group>
              </section>
            }

            <astral-button variant="primary" size="small" type="button" icon="plus" labelKey="APPENDIX.ADD_APPENDIX" (click)="addAppendix()"></astral-button>
          </div>
        </astral-accordion>

        <astral-accordion [header]="'PROPERTY.CONSUMPTION_PRICELISTS_HEADER'">
          <astral-layout-group [columns]="2" [tabletColumns]="2" [mobileColumns]="1">
            <astral-select [control]="form.controls['imdPriceListElectricityId']" [itemsSource]="imdElectricitySelection"></astral-select>
            <astral-select [control]="form.controls['imdPriceListChargingElectricityId']" [itemsSource]="imdChargingElectricitySelection"></astral-select>
            <astral-select [control]="form.controls['imdPriceListHotWaterId']" [itemsSource]="imdHotWaterSelection"></astral-select>
            <astral-select [control]="form.controls['imdPriceListColdWaterId']" [itemsSource]="imdColdWaterSelection"></astral-select>
            <astral-select [control]="form.controls['imdPriceListHeatingId']" [itemsSource]="imdHeatingSelection"></astral-select>
          </astral-layout-group>
        </astral-accordion>

        <astral-accordion [header]="'CONSUMPTION.CONSUMPTION'" (stateChanged)="allowSectionInit('consumption')">
          @if (isSectionAllowed('consumption')) {
            <div class="astral-stack-l">
              <app-period-consumption [propertyId]="dataContext.id" [meterType]="1"></app-period-consumption>
              <app-period-consumption [propertyId]="dataContext.id" [meterType]="2"></app-period-consumption>
              <app-period-consumption [propertyId]="dataContext.id" [meterType]="5"></app-period-consumption>
              <app-period-consumption [propertyId]="dataContext.id" [meterType]="3"></app-period-consumption>
              <app-period-consumption [propertyId]="dataContext.id" [meterType]="4"></app-period-consumption>
            </div>
          }
        </astral-accordion>

        @if (rentalObjectsExist) {
          <astral-accordion [header]="'DASHBOARD.OVERVIEW_ITEM_HEADER'">
            <astral-layout-group [columns]="2" [tabletColumns]="1" [mobileColumns]="1">
              @if (dwellingExist) {
                <section class="astral-section-surface astral-stack-m">
                  <h5>{{ 'STATISTICS.DWELLING_HEADER' | translate }}</h5>
                  <app-residential-property-statistics [model]="dwelling"></app-residential-property-statistics>
                </section>
              }
              @if (premisesExist) {
                <section class="astral-section-surface astral-stack-m">
                  <h5>{{ 'STATISTICS.PREMISES_HEADER' | translate }}</h5>
                  <app-residential-property-statistics [model]="premises"></app-residential-property-statistics>
                </section>
              }
              @if (parkingExist) {
                <section class="astral-section-surface astral-stack-m">
                  <h5>{{ 'STATISTICS.PARKING_HEADER' | translate }}</h5>
                  <app-non-residential-property-statistics [model]="parking"></app-non-residential-property-statistics>
                </section>
              }
              @if (otherRentalObjectExist) {
                <section class="astral-section-surface astral-stack-m">
                  <h5>{{ 'STATISTICS.OTHER_RENTAL_OBJECT_HEADER' | translate }}</h5>
                  <app-non-residential-property-statistics [model]="otherRentalObject"></app-non-residential-property-statistics>
                </section>
              }
            </astral-layout-group>
          </astral-accordion>
        }
        @if (!dataContext.isNew) {
          <astral-accordion [helpText]="'PROPERTY.HELP_TEXT.DOCUMENT_LIST'" [header]="'DOCUMENT.LIST_HEADER'" (stateChanged)="setDocumentsVisibility($event)" [allowWidthExpansion]="true">
            <div class="astral-stack-l">
              @if (allowLinkPropertyDocument) {
                <astral-button variant="primary" size="small" type="button" icon="plus" labelKey="ADD_WITH_DLG_BTN" (click)="linkDocument()"></astral-button>
              }
              <app-list-view
                [columnDefinition]="documentsColumnDefinition"
                [itemsSource]="dataContext.documents"
                [contextMenuDefinition]="documentsContextMenuDefinitions"
                [preferencesKey]="'rent.property.documents'"
              ></app-list-view>
            </div>
          </astral-accordion>
        }
      </div>
    </form>
  }
</section>
